import { Collapse, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material'
import { JSXElementConstructor, memo, ReactElement, ReactNode, ReactPortal, useState } from 'react'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { RootState } from '../../../store/store'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

export const SideBarButtonBackOffice = memo(function ({ item }: any) {
	const [open, setOpen] = useState(false)
	const dispatch = useDispatch()
	const sideBarIndex = useSelector((state: RootState) => state.sideBar)

	const handleListItemClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, index: number, name: string) => {
		setOpen(!open)
	}

	return (
		<>
			<ListItem disablePadding>
				<ListItemButton onClick={event => handleListItemClick(event, item.option, item.link)}>
					<Typography
						sx={{ color: 'black', textDecoration: 'none', paddingInlineEnd: '1rem' }}
						variant='body1'
					>
						{item.title}
					</Typography>
					{!open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
				</ListItemButton>
			</ListItem>
			<Collapse
				in={open}
				timeout='auto'
				unmountOnExit
			>
				<List
					component='div'
					disablePadding
				>
					{item.children.map(
						(
							children: {
								link: any
								title:
									| string
									| number
									| boolean
									| ReactElement<any, string | JSXElementConstructor<any>>
									| Iterable<ReactNode>
									| ReactPortal
									| null
									| undefined
							},
							index: unknown,
						) => {
							return (
								<ListItemButton sx={{ display: 'flex', justifyContent: 'center' }}>
									<Link to={children.link}>
										<ListItemText
											sx={{ color: 'black', textDecoration: 'none' }}
											primary={children.title}
										/>
									</Link>
								</ListItemButton>
							)
						},
					)}
				</List>
			</Collapse>
		</>
	)
})
